export function OutlineTagIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9812 4.89823V11.1102C20.9812 11.6132 20.7819 12.0973 20.426 12.4532L17.4363 15.4429L12.4392 20.4448C11.6941 21.1851 10.4935 21.1851 9.75318 20.4448L3.54121 14.2281C2.79616 13.4877 2.79616 12.2871 3.54121 11.5468L8.39595 6.68732L11.528 3.55523C11.884 3.19931 12.368 3 12.871 3H19.083C20.1318 3 20.9812 3.84946 20.9812 4.89823Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0232 7.94096C17.5684 7.94096 18.0103 7.49903 18.0103 6.95388C18.0103 6.40873 17.5684 5.9668 17.0232 5.9668C16.4781 5.9668 16.0361 6.40873 16.0361 6.95388C16.0361 7.49903 16.4781 7.94096 17.0232 7.94096Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.12549 13.383L12.5768 8.93164"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5979 15.8509L15.0493 11.4043"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
